
<v-menu
    offset-y
    :close-on-content-click="false"
    min-width = "1000"
    max-width="1000"
    v-if      = "preferences && user"
    v-model   = "menu"
    style     = "z-index: 10"
>
    <template v-slot:activator="{ on, attrs }">
        <div class="nav-dropdown" v-bind="attrs" v-on="on">
            <div class="mr-2 mt-1">{{ user.firstname }} {{ user.lastname }}</div>
            <v-avatar
                color="primary"
                size="30">
                <span class="white--text nav-avatar">{{ avatar }}</span>
            </v-avatar>
            <div class="mt-1 ml-1"><i class="nav-icon fas fa-caret-down"></i></div>
        </div>
    </template>

    <v-card>
        <v-row class="no-frame">
            <v-col class="col-5">
                <div style="padding: 10px; border-style: solid; border-width: 1px; border-color: lightgrey; border-radius: 10px; height: 100%">
                    <div class="no-frame mt-3" style="justify-content: center">
                        <div class="profile-avatar primary">
                            {{ avatar }}
                        </div>
                    </div>
                    <div class="v-flex mt-3">
                        <v-select
                            v-model="preferences.theme"
                            :items="themes"
                            item-value="name"
                            item-text="name"
                            @change="onTheme"
                            :label="$t('nav.user.appearance')"
                        >
                            <template slot="item" slot-scope="data">
                                <div class="v-flex">
                                    <div class="theme-preview" :style="'background: ' + data.item.primary"> </div>
                                    <div class="ml-2">{{data.item.name}}</div>
                                </div>
                            </template>
                        </v-select>
                    </div>
                    <div class="mt-0 mr-5" style="font-size: 11pt">
                        <div class="primary--text" style="font-weight: 800">
                            {{ $t('nav.user.user') }}
                        </div>
                        <div>
                            - {{ profile.username }}
                        </div>
                        <div>
                            - {{ profile.name }}
                        </div>
                        <div>
                            - {{ profile.email }}
                        </div>
                        <div class="primary--text mt-5" style="font-weight: 800">
                            {{ $t('nav.user.roles') }}
                        </div>
                        <div style="overflow-y: auto; max-height: 400px;">
                            <div v-for="(role, index) in profile.roles" :key="index">
                                - {{ role }}
                            </div>
                        </div>
                    </div>
                </div>
            </v-col>
            <v-col class="col-7 pl-0">
                <div style="padding: 10px; border-style: solid; border-width: 1px; border-color: lightgrey; border-radius: 10px; width: 100%; height: 100%;">
                    <v-tabs
                        v-model="tab"
                        :show-arrows = "false"
                        grow
                    >
                        <v-tabs-slider color="primary"></v-tabs-slider>

                        <v-tab href="#tab-customer" class="user-tab">
                            Kunden
                        </v-tab>

                        <v-tab href="#tab-preferences" class="user-tab">
                            Einstellungen
                        </v-tab>

                        <v-tab href="#tab-signature" v-if="liftmanager" class="user-tab">
                            Stempel
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item value="tab-customer">
                            <nav-user-customer />
                        </v-tab-item>

                        <v-tab-item value="tab-preferences">
                            <nav-user-preferences />
                        </v-tab-item>

                        <v-tab-item value="tab-signature">
                            <nav-user-stamp />
                        </v-tab-item>
                    </v-tabs-items>
                    <div>
                        <v-btn
                            class="logout-button"
                            color="primary"
                            @click="logout"
                            style="margin-top: 0"
                        >
                            {{ $t("nav.user.logout") }}
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-card>
</v-menu>
